/* eslint-disable max-len */
// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import React from 'react';
import { errorAlertBar } from './error-alert-bar';

const errorTypes = {
    401: 'ERROR_SESSION',
    502: 'SERVER_TOOK_TOO_LONG_TO_REPLY',
};

const getText = (response) => ({ message: <FormattedMessage id={errorTypes[response.status]} /> });

const getJson = async (response) => {

    let reply;

    const responseText = await response.text();

    try {

        reply = JSON.parse(responseText);

    } catch (error) {

        // make sure response text is not ridiculously long

        const processedResponseText = responseText.length > 500 ? responseText.slice(0, 500) : responseText;

        reply = { isTranslated: true, message: processedResponseText };

    }

    return reply;

};

export const handleError = async (response) => {

    const errorType = errorTypes[response.status];

    const reply = errorType ?
        await getText(response) :
        await getJson(response);

    errorAlertBar(reply);

    return Promise.reject(reply);

};
